'use strict';

var novicell = novicell || {};

novicell.search = novicell.search || new function () {

    var body = document.body;
    var siteNodeId = body.getAttribute('siteNodeId');
    var searchInput = document.querySelector('.search-overlay-input-container__input');
    var searchOverlay = document.querySelector('#js-search-overlay');

    this.init = function () {

        new Vue({
            el: searchOverlay,
            data: {
                params: {
                    siteNodeId: siteNodeId,
                    searchTerm: '',
                    limit: 5
                },
                previewList: {
                    items: [],
                    open: false,
                    scrollbar: false
                },
                searchInput: {
                    focus: false
                }
            },
            methods: {
                onBlur: function () {
                    this.searchInput.focus = false;
                    this.previewList.open = false;
                    this.previewList.scrollbar = false;
                },
                onFocus: function () {
                    let itemsLength = this.previewList.items.length;
                    this.searchInput.focus = true;
                    this.previewList.open = itemsLength > 0;
                    this.previewList.scrollbar = itemsLength > 3;
                },
                onChange: novicell.debounce(function () {
                    axios
                        .get('/umbraco/api/searchApi/Search', {
                            params: this.params
                        })
                        .then(response => {
                            let content = response.data.content;

                            content.forEach(function(el){
                                if(el.listImageUrl)
                                {
                                    el.listImageUrl += "?height=50&width=50&mode=crop&quality=70&center=0.5,0.5";
                                }
                            });

                            let itemsLength = content.length;
                            this.previewList.items = content;
                            this.previewList.open = itemsLength > 0;
                            this.previewList.scrollbar = itemsLength > 3;
                            
                        })
                        .catch(error => (console.log(error)))
                }, 500)
            }
        })

        // var searchButton = document.querySelector('#js-search-overlay-trigger');

        // if (!searchButton) {
        //     return;
        // }
        // // Open search overlay
        // searchButton.addEventListener('click', clickSearchButton);
    };

    // function clickSearchButton(e) {
    //     e.preventDefault();

    //     closeOverlayHandler();
    //     body.classList.add('search-overlay-open');
    //     searchInput.focus();
    // }

    // function closeOverlayHandler() {
    //     document.addEventListener('keydown', handleEsc, true);
    //     document.addEventListener('click', handleClick, true);
    // }

    // function closeSearchOverlay() {
    //     body.classList.remove('search-overlay-open');
    //     searchInput.blur();
    //     searchInput.value = '';
    //     document.removeEventListener('keydown', handleEsc, true);
    //     document.removeEventListener('click', handleClick, true);
    // }

    // function handleEsc(e) {
    //     if (e.keyCode === 27) {
    //         closeSearchOverlay();
    //     }
    // }

    // function handleClick(e) {
    //     var targetElement = e.target;
    //     do {
    //         if (targetElement == searchOverlay) {
    //             // This is a click inside. Do nothing, just return.
    //             return;
    //         }
    //         targetElement = targetElement.parentNode;
    //     } while (targetElement);

    //     // This is a click outside.
    //     closeSearchOverlay();
    // }
}();
